import { memo, type ReactNode } from "react";
import type { Node, NodeProps } from "@xyflow/react";
import { SeedanceComposerOverlay } from "../composer/SeedanceComposerOverlay.js";
import type { ComposerLayout } from "../composer/composer-layout.js";

export interface ComposerFlowNodeData extends Record<string, unknown> {
  nodeId: string;
  node: {
    canvasPosition: { x: number; y: number };
    size: { width: number; height: number };
  };
  flowViewport: { x: number; y: number; zoom: number };
  canvasViewport: { width: number; height: number };
  layout?: ComposerLayout;
  children: ReactNode;
}

export type ComposerFlowNodeType = Node<ComposerFlowNodeData, "composer">;

export const ComposerFlowNode = memo(function ComposerFlowNode({ data }: NodeProps<ComposerFlowNodeType>) {
  return (
    <SeedanceComposerOverlay
      nodeId={data.nodeId}
      node={data.node}
      flowViewport={data.flowViewport}
      canvasViewport={data.canvasViewport}
      layout={data.layout ?? "floating"}
      host="node"
    >
      {data.children}
    </SeedanceComposerOverlay>
  );
});
